module.exports = "<wow-dynamic-suburb-dialog ng-if=\"$ctrl.shouldDisplayDynamicSuburbDialog\"></wow-dynamic-suburb-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/shop/notificationpanel/notification-panel.component.html
// module id = 498
// module chunks = 0